import { Form } from 'antd';
import React, { useEffect } from 'react';
import Button from '../../../components/Button/Button';
import { Login as LoginPayload } from '../../../models/auth';
import { useNavigate  } from 'react-router-dom';

import styles from './Logout.module.scss';
import { useUserStore } from '../../../store/useUser';
import { useSidebarStore } from '../../../store/useSidebar';

import useHeader from '../../../hooks/useHeader';

const Logout: React.FC = () => {
    const [form] = Form.useForm();

    const reset = useUserStore((state) => state.reset);
    const setMenu = useSidebarStore(state=> state.setMenu)

    const navigate = useNavigate();

    useHeader({ header: 'Sair' });

    const onFinish = async (payload: LoginPayload): Promise<void> => {
        reset();
        setMenu();
        navigate('/');
    }

    return (
        <div className={styles.container}>
            <div className={styles.maskContainer}></div>
            <div className={styles.authenticationContainer}>
                <div className={styles.authenticationForm}>
                    <Form 
                        layout="vertical" 
                        onFinish={onFinish} 
                        hideRequiredMark 
                        id="formLogin" 
                        className={styles.FormContainer}>
                        <h1 className={styles.title}>Você deseja sair?</h1>
                        <Button submit style={styles.button}>Sair</Button>
                    </Form>
                    <div className={styles.redirectLink}>
                  </div>
                </div>
            </div>
        </div>
    )
}

export default Logout;